module.exports = {
  title: `Youthfulhps.dev`,
  description: `프론트엔드 주니어 개발자, 트러블슈팅에 대한 고민의 흔적을 기록으로 남기는 것을 좋아합니다.`,
  author: `youthfulhps`,
  introduction: `프론트엔드 주니어 개발자, 트러블슈팅에 대한 고민의 흔적을 기록으로 남기는 것을 좋아합니다.`,
  siteUrl: `https://youthfulhps.dev`,
  thumbnail: '/banner.png',
  social: {
    twitter: ``,
    github: `youthfulhps`,
    medium: ``,
    facebook: ``,
    linkedin: ``,
    instagram: `youthfulhps`,
  },
  icon: `static/favicon.svg`,
  keywords: [`blog`, 'javascript', 'web', 'react', 'frontend', 'development'],
  comment: {
    disqusShortName: 'youthfulhps', // Your disqus-short-name. check disqus.com.
    utterances: 'youthfulhps/youthfulhps.github.io', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'youthfulhps',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'G-7RNTEYXV6R', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`
};
